import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { storeAdmins } from "../../../../MyApi/admins";
import { getRoles } from "../../../../MyApi/vendors";
import { toast } from "react-toastify";

const CreateAdminModal = ({ show, onClose, refetch }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    is_active: 1,
    role: "",
    guard_name: "admin",
  });
  const { data } = useQuery("getRoles", () => getRoles("admin"));
  const roles = data?.data?.roles || [];
  console.log("admin roles", roles);

  const mutation = useMutation({
    mutationFn: (postData) => storeAdmins(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
      onClose();
    },
    onError: (err) => {
      toast.error(`${err.response.data.message}`);
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate(formData);
  };

  return (
    <Modal isOpen={show} toggle={onClose} className="add">
      <ModalHeader toggle={onClose}>إنشاء مشرف جديد</ModalHeader>
      <ModalBody>
        <Form >
          <FormGroup>
            <Label> الاسم الأول</Label>
            <Input
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>الاسم الاخير </Label>
            <Input
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>الإيميل</Label>
            <Input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>الهاتف</Label>
            <Input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>كلمة المرور</Label>
            <Input
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>الحالة</Label>
            <Input
              type="select"
              name="is_active"
              value={formData.is_active}
              onChange={handleChange}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>الدور</Label>
            <select
              className="form-select"
              name="role"
              value={formData.role}
              onChange={handleChange}
            >
              <option value="">اختر الدور</option>  
              {roles.map((role) => (
                <option value={role.name} key={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Form>
      </ModalBody>

      <ModalFooter className="justify-content-start">
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={mutation.isLoading}
        >
          {mutation.isLoading ? "Saving..." : "حفظ   "}
        </Button>
        <button
          className="btn btn-white"
          onClick={onClose}
          disabled={mutation.isLoading}
        >
          إلغاء
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateAdminModal;
